import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AuthService } from "./core/services/default/auth.service";
import { MixpanelService } from './core/services/mixpanel.service';

import { delay } from "rxjs/operators";
import Swal from "sweetalert2";
import { CorePermissionService } from "./core/services/core-permission.service";
import { FrontChatService } from './core/services/frontchat.service';
import { LoadingService } from "./core/services/loading.service";
import { error, errorHtml } from "./utils/swal.model";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "VinhoBidWeb";
  user = false;
  message$ = false;
  loading: boolean = false;

  constructor(
    private auth: AuthService,
    private router: Router,
    private loadingService: LoadingService,
    private corePermissionService: CorePermissionService,
    private mixpanel: MixpanelService,
    private frontChat: FrontChatService
  ) { }

  ngOnInit(): void {
    this.auth.showingMessage$.subscribe(
      (status: boolean) => (this.message$ = status)
    );
    this.routeEvent(this.router);
    this.setUser();
    this.handleLoading();
    if (this.auth.isTokenValid()) {
      this.corePermissionService.getCanBid();
    }
    this.frontChat.init();
  }

  routeEvent(router: Router) {
    router.events.subscribe(async (e) => {
      if (e instanceof NavigationEnd) {
        const pageName = this.getPageName(e.urlAfterRedirects);

        this.mixpanel.track(`Página Acessada | ${pageName}`, {
          rota: e.urlAfterRedirects
        });

        await this.showMessage(this.message$);
      }
    });
  }

  getPageName(url: string): string {
    const map = {
      '/': 'Início',
      '/leiloes': 'Leilões',
      '/como-funciona': 'Como Funciona',
      '/lote/cadastrar': 'Quero Vender',
    };

    return map[url] || url;
  }

  setUser() {
    if (this.auth.isTokenValid()) {
      this.corePermissionService.getCanBid();
      const storageUser = JSON.parse(localStorage.getItem("user"));

      if (storageUser?.userToken && storageUser?.userLoginInfo) {
        const userEmail = storageUser.userLoginInfo.email;
        const userName = storageUser.userLoginInfo.name;

        this.auth.setUserInfo(storageUser);

        this.mixpanel.identify(userName);

        this.mixpanel.setUserProperties({
          $email: userEmail,
          name: userName || '',
          tipoUsuario: storageUser.userLoginInfo.typeUser,
          cidade: storageUser.userLoginInfo.city,
          estado: storageUser.userLoginInfo.state,
          ultimoAcesso: storageUser.userLoginInfo.lastAccess,
          criadoEm: storageUser.userLoginInfo.createAt
        });
      }
    }
  }


  showMessage(message) {
    const title = "Sua sessão expirou!";
    const text = "Você será redirecionado para a página de login.";
    const confirmButtonText = "Efetuar login";

    if (!message) {
      return;
    }

    return Swal.fire({
      ...error,
      html: errorHtml(title, text),
      confirmButtonText,
    }).then(() => {
      this.message$ = false;
      this.auth.setMessageStatus(false);
      this.auth.logout();
      return this.router.navigate(["/login"]);
    });
  }

  handleLoading(): void {
    this.loadingService.loading$.pipe(delay(0)).subscribe((loading) => {
      this.loading = loading;
    });
  }
}
